import React, { useEffect, useState } from "react";
import { SelectInputComponent } from "../../../../common/components";
import { CREATED_TIME_OPTIONS } from "../../../leads/lead-filter/lead-filter.constant";
import CustomDateRangePicker from "../../../leads/lead-filter/lead-filter-options/custom-date-picket";
import dayjs, { Dayjs } from "dayjs";
import { calculateDateRange } from "../../../../utils/filtersUtil";

interface LastSubmissionFilterProps {
  value: string;
  onChange: (value: string) => void;
  isLastSubmissionEnabled?: boolean;
  onDateRangeChange: (fromDate: Date | null, toDate: Date | null) => void;
  lastSubmissionError?: string;
  lastSubmissionStartError?: string;
  lastSubmissionEndError?: string;
  setLastSubmissionFromDate: (date: Dayjs | null) => void;
  setLastSubmissionToDate: (date: Dayjs | null) => void;
  fromDate?: Dayjs | null;
  toDate?: Dayjs | null;
}

const LastSubmissionFilter: React.FC<LastSubmissionFilterProps> = ({
  value,
  onChange,
  isLastSubmissionEnabled,
  onDateRangeChange,
  lastSubmissionError,
  lastSubmissionStartError,
  lastSubmissionEndError,
  setLastSubmissionFromDate,
  setLastSubmissionToDate,
  fromDate,
  toDate
}) => {
  const [showCustomDate, setShowCustomDate] = useState(false);
  const [selectOpen, setSelectOpen] = useState(false);
  const handleOpen = () => {
    setSelectOpen(true)
  }
  const handleBlur = () => {
    setSelectOpen(false)
  }
  useEffect(() => {
    const selected = typeof value === "object" ? "" : value;
    setShowCustomDate(value.includes("Custom"));

    if (selected && selected !== "Custom") {
      const { from, to } = calculateDateRange(selected);
      onDateRangeChange(from ? from.toDate() : null, to ? to.toDate() : null);
    }
  }, [value]);

  const handleCustomRangeChange = (from: Dayjs | null, to: Dayjs | null) => {
    onDateRangeChange(from?.toDate() || null, to?.toDate() || null);
  };
  if (!isLastSubmissionEnabled) return null;


  return (
    <div className="filter-select-input-wrapper">
      <SelectInputComponent
        fieldName="lastSubmission"
        options={CREATED_TIME_OPTIONS}
        onChange={onChange}
        value={value}
        placeholder=" Select Last Submission"
        //multiple={true}
        isFilter={true}
        selectOpen={selectOpen}
        handleOpen={handleOpen}
        handleBlur={handleBlur}
      />
      {lastSubmissionError && <div className="error-text">{lastSubmissionError}</div>}
      {showCustomDate && (
        <div>
          <CustomDateRangePicker
            fromDate={fromDate}
            toDate={toDate}
            onDateRangeChange={handleCustomRangeChange}
            startDateError={lastSubmissionStartError}
            endDateError={lastSubmissionEndError}
            setFromDate={setLastSubmissionFromDate}
            setToDate={setLastSubmissionToDate}
          />
        </div>
      )}
    </div>
  );
};

export default LastSubmissionFilter;
